<div class="content-area">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Offers</h2>
  <button class="btn btn-success btn-sm" (click)="exportToExcel(offers)">Download .xlsx ({{ status }})</button>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'project_id'">Angebot</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde</clr-dg-column>
    <clr-dg-column [clrDgField]="'offer_lastname'">Ansprechpartner</clr-dg-column>
    <clr-dg-column>Anfrage-/Bestellnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'offer_date'" [clrDgSortOrder]="descSort">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'budget'">Summe (netto)</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Offers!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let offer of offers">
      <clr-dg-cell [routerLink]="['/offer/details', offer.project_id, offer.offer_id]">{{ offer.project_id }}.0003.{{ offer.offer_id }}</clr-dg-cell>
      <clr-dg-cell><b>{{ offer.name_project }}</b></clr-dg-cell>
      <clr-dg-cell [routerLink]="['/offer/details', offer.project_id, offer.offer_id]">{{ offer.company_name }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/offer/details', offer.project_id, offer.offer_id]">{{ offer.offer_salutation}} {{ offer.offer_firstname}} {{ offer.offer_lastname}}</clr-dg-cell>
      <clr-dg-cell>{{ offer.request_id }}<br />{{ offer.order_id }}</clr-dg-cell>
      <clr-dg-cell>{{ offer.offer_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell class="currency"><b>{{ offer.budget | currency: 'EUR':'code':'1.2-2':'de'  }}</b></clr-dg-cell>
      <clr-dg-cell  [className]="findButtonClass(offer.status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <span class="alert-text">{{ getCellStatus(offer.status).statusDisplay}}</span>
          </div>
        </div>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Rechnungen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von  {{ offers.length }} Angebot(e)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
